
import ToDoList from "../../assets/todolist.svg";
import google from "../../assets/logo/google-color.svg";
import microsoft from "../../assets/logo/microsoft.svg";
import amazon from "../../assets/logo/amazon-a-logo.svg";
import ongc from "../../assets/logo/ongc_logo.png"
import sprinklr from "../../assets/logo/sprinklr-logo.svg";
import { useNavigate } from "react-router-dom";
import { PastrecruitersContainer,logo_style,Button,Svg1,Svg2,Card } from './StyledComponents'


export default function PastRecruiters() {
  const navigate = useNavigate();
  return (
    <>
      <PastrecruitersContainer>
        <Svg1 src={ToDoList} />
        <Svg2 src={ToDoList} />
        <h1 className="heading"> Past Recruiters</h1>
        <p className="paragraph">
          The institute has had active relations with many corporations of high
          repute for several decades. Some of the prominent recruiters are:
        </p>
        <div className="company_container">
          <Card onClick={(event) => (navigate("/placement/Google%20India/2022"))}>
            <h3>GOOGLE</h3>
            <img style={logo_style} alt="google logo" src={google}></img>
          </Card>
          <Card onClick={(event) => (navigate("/placement/Microsoft/2022"))}>
            <h3>MICROSOFT</h3>
            <img style={logo_style} alt="google logo" src={microsoft}></img>
          </Card>
          <Card onClick={(event) => (navigate("/placement/Amazon/2022"))}>
            <h3>AMAZON</h3>
            <img style={logo_style} alt="google logo" src={amazon}></img>
          </Card>
          <Card onClick={(event) => (navigate("/placement/ONGC/2022"))}>
            <h3>ONGC</h3>
            <img style={logo_style} alt="google logo" src={ongc}></img>
          </Card>
          <Card onClick={(event) => (navigate("/placement/SPRINKLR(PE%20&%20DS)/2021"))}>
            <h3>SPRINKLR</h3>
            <img
              style={{ height: "40%" }}
              alt="google logo"
              src={sprinklr}
            ></img>
          </Card>
        </div>
        <Button 
          onClick={(event) => (navigate("/insight"))}
        >
          View All
        </Button>
      </PastrecruitersContainer>
    </>
  );
}
